export enum ProjectActionStatusDisplayName {
    Open = 'Open',
    InProgress = 'In Progress',
    ImpedimentEncountered = 'Impediment Encountered',
    Completed = 'Completed'
}